module.exports=function(e){var t={};function o(n){if(t[n])return t[n].exports;var r=t[n]={i:n,l:!1,exports:{}};return e[n].call(r.exports,r,r.exports,o),r.l=!0,r.exports}return o.m=e,o.c=t,o.d=function(e,t,n){o.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},o.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},o.t=function(e,t){if(1&t&&(e=o(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(o.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var r in e)o.d(n,r,function(t){return e[t]}.bind(null,r));return n},o.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return o.d(t,"a",t),t},o.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},o.p="",o(o.s=65)}({1:function(e,t){e.exports=require("react")},2:function(e,t){e.exports=require("styled-components")},3:function(e,t){e.exports=require("../../styles")},5:function(e,t){e.exports=require("../Icon/Icon")},65:function(e,t,o){"use strict";var n=this&&this.__createBinding||(Object.create?function(e,t,o,n){void 0===n&&(n=o),Object.defineProperty(e,n,{enumerable:!0,get:function(){return t[o]}})}:function(e,t,o,n){void 0===n&&(n=o),e[n]=t[o]}),r=this&&this.__setModuleDefault||(Object.create?function(e,t){Object.defineProperty(e,"default",{enumerable:!0,value:t})}:function(e,t){e.default=t}),i=this&&this.__importStar||function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var o in e)"default"!==o&&Object.hasOwnProperty.call(e,o)&&n(t,e,o);return r(t,e),t},l=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(t,"__esModule",{value:!0});const a=i(o(1)),d=i(o(2)),u=l(o(66)),s=l(o(8)),c=o(3),f=l(o(5)),{KineduPalette:p}=c.colorPalettes,m=d.default.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.7);
  background: ${({overlayColor:e})=>e};
  z-index: 10000;
  opacity: 0;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;

  transition: opacity 0.3s ease-out;

  ${({state:e})=>"entered"===e&&"\n    opacity: 1;\n  "}
`,g=d.default.div`
  position: relative;
  top: 50px;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  min-height: 60px;
  margin: auto;
  margin: ${({mobileMargin:e})=>Number.isInteger(e)?`auto ${e}px`:e};
  opacity: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;

  ${({roundedCorners:e})=>e&&"\n    border-radius: 4px;\n  "}

  ${({fullMobile:e})=>e&&`\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n\n    ${c.breakPoints.tablet} {\n      height: auto;\n      margin: auto;\n    }\n  `}

  background-color: white;
  color: ${p.shadeDark};

  z-index: 10000;
  transition: 0.3s;
  animation: mounting 0.3s 1;
  animation-timing-function: ease-out;

  ${({state:e})=>"entered"===e&&"\n    top: 0;\n    opacity: 1;\n  "}

  ${c.breakPoints.tablet} {
    max-width: ${({width:e})=>Number.isInteger(e)?e+"px":e};
    margin: auto;
  }
`,b=d.default.div`
  position: relative;
  display: none;
  grid-template-columns: 1fr 40px;
  justify-content: flex-start;
  align-items: center;

  width: 100%;
  min-height: 60px;
  background-color: ${({color:e})=>e||p.newKinedu};
  padding: 10px 20px;
  box-sizing: border-box;

  ${({show:e})=>e&&d.css`
    display: grid;
  `}
`,h=d.default.span`
  color: white;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: -0.5px;
  line-height: 24.5px;

  ${c.breakPoints.desktop} {
    font-size: 20px;
  }

  ${({titleAlign:e})=>"text-align: "+e}
`,x=d.default.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;

  display: flex;
  justify-content: flex-end;
  padding: 12px;
`,y=d.default(f.default).attrs(({color:e,closeIconName:t="close"})=>({name:t,color:e,size:35}))`
  padding: 4px;
  box-sizing: border-box;
  cursor: pointer;
  z-index: 1;
`;t.default=({children:e,className:t,closeButtonColor:o,closeIconName:n,headerColor:r,mobileMargin:i=0,onClosedModal:l=(()=>{}),openModal:d,overlayColor:c,roundedCorners:f=!0,showCloseButton:v=!0,closeOnBackdrop:w=!0,submitModal:_,title:M,titleAlign:P="left",width:j=620})=>{const[O,k]=a.useState(!0),$=e=>{document.body.style.overflow=e};a.useEffect(()=>{const e=d?"hidden":"scroll";k(d),$(e)},[d]);const C=()=>{k(!1),l(),$("")};return d?a.default.createElement(s.default,{rootId:"modal-root"},a.default.createElement(u.default,{in:O,timeout:300,unmountOnExit:!0,appear:!0},l=>a.default.createElement(m,{"data-testid":"lego-modal-overlay",onClick:w?()=>C():()=>{},state:l,overlayColor:c},a.default.createElement(g,{"data-testid":"lego-modal-styled",roundedCorners:f,width:j,onClick:e=>{e.stopPropagation()},className:"modal "+t,state:l,mobileMargin:i},a.default.createElement(b,{"data-testid":"lego-modal-header",className:"modal-header",show:!!M,color:r},"function"==typeof M?M():a.default.createElement(h,{"data-testid":"lego-modal-header-title",titleAlign:P},M)),v&&a.default.createElement(x,{"data-testid":"lego-modal-icon-wrapper",className:"modal-close-wrapper"},a.default.createElement(y,{"data-testid":"lego-modal-close-button",className:"modal-close-icon",closeIconName:n,onClick:C,color:o||p.shadeMediumLight})),e({closeModal:C,submitModal:_,openModal:d}))))):null}},66:function(e,t){e.exports=require("react-transition-group/Transition")},8:function(e,t){e.exports=require("../Portal/Portal")}});